import Z3 from './components/Z3';
import Z4 from './components/Z4';
import Z5 from './components/Z5';
import Z6 from './components/Z6';
import Z7 from './components/Z7';
import Z8 from './components/Z8';
import Z9 from './components/Z9';
import { ZBComp } from './components/ZB';
import { ZCComp } from './components/ZC';
import { ZDComp } from './components/ZD';
import { ZEComp } from './components/ZE';
import { ZFComp } from './components/ZF';
import { ZGComp } from './components/ZG';
import { ZIComp } from './components/ZI';
import { ZKComp } from './components/ZK';
import Z8_AU from './components/Z8_AU';
import FixTab from './components/FixTab';
// import FAQ from './components/FAQ';
import styles from './index2.module.scss';
import { BundleList } from '@/components/ProductCommon/bundle-list';
import AppPointDeltaAdv from '@/components/AppPoint/DeltaAdvPC';
import NextImage from '@/components/NextImage';
import EfScrollAni from '@/efscrollani';

export default function IndexDynamicAU({ stage }: any) {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div
            className={`${styles.delta2MaxDetail} GtmModuleData-container`}
            data-container-id={styles.delta2MaxDetail}
            data-container-title="EcoFlow DELTA 2 Max"
        >
            <FixTab />
            <div className="common-comp-wrapper au-z2">
                <NextImage src={require('@publicLocal/delta2max/teaser/pc/eu/au_2.png')} alt="EcoFlow DELTA 2 Max" aria-label="EcoFlow DELTA 2 Max" />
            </div>
            <Z9 />
            <div className="common-comp-wrapper">
                <ZBComp />
                {/* 新模块 */}
                <Z8_AU />
            </div>
            <div className="common-comp-wrapper">
                <ZCComp />
            </div>
            <div className="common-comp-wrapper">
                <ZDComp />
            </div>
            <div className="common-comp-wrapper">
                <ZEComp />
            </div>
            <div className="common-comp-wrapper">
                <ZFComp />
            </div>
            <div className="common-comp-wrapper">
                <ZGComp />
            </div>
            <Z3 />
            <Z4 />
            <Z5 />
            <Z7 />
            <Z6 />
            <Z8 />
            <div className="common-comp-wrapper" id="app-upgraded">
                <AppPointDeltaAdv />
            </div>
            <div className="common-comp-wrapper" style={{ marginTop: '0' }}>
                <ZIComp />
            </div>
            <div className="common-comp-wrapper">
                <ZKComp />
            </div>
            {/* <FAQ /> */}
            {/* 预热页不展示推荐产品 */}
            {stage === 'detail' && (
                <div className="common-comp-wrapper">
                    <BundleList list={['d2mEC', 'd2mWave2_au', 'd2m220']} moreUrl="https://au.ecoflow.com/collections/delta-2-max" theme="grey" />
                </div>
            )}
        </div>
    );
}
